<div *ngIf="!gravando && !audioURL" class="flex items-center gap-2">
    <button mat-icon-button class="grid place-items-center w-9 h-9 rounded-full hover:bg-black/10"
        (click)="iniciarGravacao()">
        <mat-icon class="text-gray-500">mic</mat-icon>
    </button>
</div>

<div *ngIf="gravando" class="flex items-center gap-2">
    <div class="flex items-center gap-2 w-[190px] sm:w-[210px] h-9">
        <div class="grid place-items-center w-6 h-6 rounded-full" [ngClass]="{'mic-gravando': gravando}">
            <mat-icon class="text-white">mic</mat-icon>
        </div>

        <div class="text-sm text-black font-medium tempo-gravacao">{{ tempoGravacao }}</div>

        <div class="linha-gravacao"></div>

    </div>

    <div class="flex gap-1.5 items-center">
        <button mat-icon-button (click)="pararGravacao()"
            class="w-9 h-9 grid place-items-center rounded-full hover:bg-black/10">
            <mat-icon class="text-gray-500">stop</mat-icon>
        </button>

        <button mat-icon-button (click)="finalizarGravacao(true)"
            class="w-9 h-9 grid place-items-center rounded-full bg-green-500/20 hover:bg-green-500/30 transition">
            <mat-icon class="text-green-600">send</mat-icon>
        </button>
    </div>
</div>

<div *ngIf="!gravando && audioURL" class="flex items-center gap-1.5">

    <div class="chat-audio-preview">
        <audio [src]="audioURL" controls></audio>
    </div>

    <div class="flex gap-1.5 items-center">
        <button mat-icon-button (click)="descartarAudio()"
            class="w-9 h-9 grid place-items-center rounded-full hover:bg-black/10">
            <mat-icon class="text-gray-500">delete</mat-icon>
        </button>

        <button mat-icon-button (click)="finalizarGravacao(true)"
            class="w-9 h-9 grid place-items-center rounded-full bg-green-500/20 hover:bg-green-500/30 transition">
            <mat-icon class="text-green-600">send</mat-icon>
        </button>
    </div>
</div>